module.exports = __webpack_public_path__ + "static/media/YF53_2.945088bd.jpg";